"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Modal = exports.MODAL_SIZES = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _Modal = _interopRequireDefault(require("react-overlays/Modal"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _tabbable = require("tabbable");
var _isReactFragment = require("../utils/isReactFragment");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _AlertDialogContext = require("../utils/_AlertDialogContext");
var _focusManager = require("../utils/focusManager");
var _ModalManagerContext = require("../utils/_ModalManagerContext");
var _useModalManager = require("../utils/useModalManager");
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _Fade = require("./_Fade");
var _ModalBody = require("./_ModalBody");
var _ModalFooter = require("./_ModalFooter");
var _ModalHeader = require("./_ModalHeader");
var _ModalSubhead = require("./_ModalSubhead");
var _ModalTitle = require("./_ModalTitle");
var _Modal2 = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal.css") : void 0);
const _excluded = ["backdropClassName", "className", "children", "customFocusManager", "containerClassName", "draggable", "modalContainerClassName", "modalContainerProps", "modalContentProps", "fullscreen", "isModal", "onHide", "onShow", "resizable", "show", "size"];
/* eslint-disable react/no-multi-comp */
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const CSS_BLOCK = 'sapcnqr-modal';
const MODAL_SIZES = exports.MODAL_SIZES = ['lg', 'md', 'sm', 'xl'];

/**
 * The **Modal** component acts as a dialog box overlaid on top of the page. This allows the user
 * to focus on specific content before returning to the underlying application page.
 *
 * **Modal** consists of a header component (with or without a close box), a title
 * component, a body component, and a footer component (plus an optional subheading
 * component below the title).
 */

const Modal = exports.Modal = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const alertDialog = (0, _react.useContext)(_AlertDialogContext.AlertDialogContext);
  const titleId = (0, _useUniqueId.default)();
  const subheadId = (0, _useUniqueId.default)();
  const bodyId = (0, _useUniqueId.default)();
  const subHeaderExists = (0, _react.useRef)(false);
  const titleIdRef = (0, _react.useRef)(titleId);
  const subheadIdRef = (0, _react.useRef)(subheadId);
  const bodyIdRef = (0, _react.useRef)(bodyId);
  const {
      backdropClassName,
      className,
      children,
      customFocusManager,
      containerClassName,
      draggable,
      modalContainerClassName,
      modalContainerProps,
      modalContentProps,
      fullscreen,
      isModal = true,
      onHide,
      onShow,
      resizable,
      show,
      size = 'lg'
    } = props,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  const classnames = _bind.default.bind(_Modal2.default);
  const containerRef = (0, _react.useRef)();
  const mergedContainerRef = (0, _reactMergeRefs.default)([containerRef, modalContainerProps?.ref]);
  const modalRef = (0, _react.useRef)();
  const mergedRef = (0, _reactMergeRefs.default)([ref, modalRef]);
  const contentRef = (0, _react.useRef)();
  const mergedContentRef = (0, _reactMergeRefs.default)([contentRef, modalContentProps?.ref]);
  const modalManager = (0, _useModalManager.useModalManager)();
  let modalContentId = (0, _useUniqueId.default)();
  if (modalContentProps?.id) {
    modalContentId = modalContentProps.id;
  }
  const modalClasses = classnames(CSS_BLOCK, className, {
    [`${CSS_BLOCK}--fullscreen`]: fullscreen
  });
  const modalContainerClasses = classnames(`${CSS_BLOCK}__container`, modalContainerClassName, {
    [`${CSS_BLOCK}__container--${size}`]: size !== 'md',
    [`${CSS_BLOCK}__container--non-modal`]: !isModal
  });
  const containerClasses = classnames(containerClassName, {
    [`${CSS_BLOCK}__open`]: isModal,
    [`${CSS_BLOCK}__open--non-modal`]: !isModal
  });
  const backdropClasses = classnames(`${CSS_BLOCK}__backdrop`, backdropClassName, {
    [`${CSS_BLOCK}__backdrop--fullscreen`]: fullscreen
  });
  const _handleFocusManager = () => {
    if (alertDialog) {
      if (modalRef?.current) {
        const {
          dialog
        } = modalRef.current;

        // eslint-disable-next-line no-unused-expressions
        dialog && new _focusManager.FocusManager({
          trapNode: dialog,
          suppressInitialAttachment: true
        });
      }
    } else if (customFocusManager) {
      customFocusManager();
    } else if (isModal) {
      setTimeout(() => {
        if (modalRef?.current) {
          const {
            dialog
          } = modalRef.current;

          // focus first focusable element in modal body
          let firstFocusIndex = 0;
          let closeButtonExists = false;
          _react.default.Children.forEach(children, child => {
            if (child?.type?.displayName === _ModalHeader.ModalHeader.displayName) {
              if (child.props.closeButton) {
                closeButtonExists = true;
              }
            } else if (child?.type?.displayName === _ModalBody.ModalBody.displayName) {
              const bodyNode = dialog?.querySelector(`[data-nui-widgets="${_ModalBody.ModalBody.displayName}"]`);
              if (bodyNode && (0, _tabbable.tabbable)(bodyNode).length > 0 && (closeButtonExists || draggable)) {
                if (closeButtonExists) firstFocusIndex += 1;
                if (draggable) firstFocusIndex += 1;
              }
            }
          });

          // eslint-disable-next-line no-unused-expressions
          dialog && new _focusManager.FocusManager({
            trapNode: dialog,
            firstFocusIndex
          });
        }
      }, 500); // needs to match the delay in DataGrid to ensure gridManager is loaded
    }
  };
  const dialogTransitionRef = (0, _react.useRef)(transitionProps => /*#__PURE__*/_react.default.createElement(_Fade.Fade, (0, _extends2.default)({
    isModal: isModal
  }, transitionProps)));
  const backdropTransitionRef = (0, _react.useRef)(transitionProps => /*#__PURE__*/_react.default.createElement(_Fade.Fade, (0, _extends2.default)({
    isModal: isModal,
    timeout: 150
  }, transitionProps)));
  const passChildProps = child => {
    if (child.displayName === 'DataGrid') {
      return {
        backgroundType: 'panel'
      };
    }
    return null;
  };
  const alterHeaderChildren = childNodes => _react.default.Children.forEach(childNodes, modalHeaderChild => {
    if ((0, _isReactFragment.isReactFragment)(modalHeaderChild)) {
      alterHeaderChildren(modalHeaderChild?.props?.children);
    }
    if (modalHeaderChild?.type?.displayName === 'Modal.Title') {
      titleIdRef.current = modalHeaderChild.props.id || titleId;
    } else if (modalHeaderChild?.type?.displayName === 'Modal.Subhead') {
      subheadIdRef.current = modalHeaderChild.props.id || subheadId;
      subHeaderExists.current = true;
    }
  });
  const statefulChildren = (0, _react.useMemo)(() => _react.default.Children.map(children, child => {
    if (child?.type?.displayName === _ModalHeader.ModalHeader.displayName) {
      alterHeaderChildren(child?.props.children);
      return /*#__PURE__*/_react.default.cloneElement(child, {
        titleId: titleIdRef.current,
        // passthrough to Modal.Title component
        subheadId: subheadIdRef.current,
        // passthrough to Modal.Header component
        onHide,
        className: classnames({
          [`${CSS_BLOCK}__header--subheader`]: subHeaderExists.current
        }, child.props.className),
        draggable: draggable && !fullscreen ? draggable : undefined,
        updateStyle: styleValue => {
          if (containerRef?.current) {
            containerRef.current.style.top = styleValue.top;
            containerRef.current.style.left = styleValue.left;
            containerRef.current.style.margin = 'auto';
          }
        },
        containerRef,
        modalContentId
      });
    }
    if (child?.type?.displayName === _ModalBody.ModalBody.displayName) {
      bodyIdRef.current = child?.props?.id || bodyId;
      return /*#__PURE__*/_react.default.cloneElement(child, {
        id: bodyIdRef.current,
        isResizable: !!resizable
      });
    }
    if (child?.type?.displayName === _ModalFooter.ModalFooter.displayName) {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        resizable: resizable && !fullscreen ? resizable : undefined,
        updateStyle: styleValue => {
          if (contentRef?.current) {
            contentRef.current.style.height = styleValue.height;
            contentRef.current.style.width = styleValue.width;
            containerRef.current.style.marginBottom = 'auto';
          }
        },
        contentRef,
        modalContentId
      });
    }
    return child;
  }), [children, draggable, fullscreen, resizable, titleId, subheadId, bodyId, modalContentId]);
  let ariaDescribedBy;
  if (alertDialog) {
    ariaDescribedBy = bodyIdRef.current;
  } else if (subHeaderExists.current) {
    ariaDescribedBy = subheadIdRef.current;
  }
  return /*#__PURE__*/_react.default.createElement(_Modal.default, (0, _extends2.default)({}, otherProps, {
    "aria-describedby": ariaDescribedBy,
    "aria-labelledby": otherProps['aria-labelledby'] || titleIdRef.current,
    backdrop: isModal ? 'static' : false,
    backdropTransition: backdropTransitionRef.current,
    className: modalClasses,
    containerClassName: containerClasses,
    enforceFocus: false,
    manager: modalManager,
    onHide: onHide,
    onShow: (0, _chainFunction.default)(_handleFocusManager, onShow),
    ref: mergedRef,
    renderBackdrop: () => /*#__PURE__*/_react.default.createElement("div", {
      className: backdropClasses
    }),
    role: alertDialog ? 'alertdialog' : undefined,
    show: show,
    transition: dialogTransitionRef.current
  }), /*#__PURE__*/_react.default.createElement(_ModalManagerContext.ModalManagerContext.Provider, {
    value: modalManager
  }, /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, modalContainerProps, {
    className: modalContainerClasses,
    ref: mergedContainerRef
  }), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, modalContentProps, {
    id: modalContentId,
    className: classnames(`${CSS_BLOCK}__content`, modalContentProps?.className),
    role: "document",
    ref: mergedContentRef,
    "data-nui-widgets": "modal-content"
  }), statefulChildren)))));
});
Modal.displayName = 'Modal';
Modal.propTypes = _objectSpread(_objectSpread({}, _Modal.default.propTypes), {}, {
  /** Custom classes to add to the **Modal** backdrop’s `<div>` tag. */
  backdropClassName: _propTypes.default.string,
  /** The content of the **Modal** specifically the `Modal.Header`,
   * `Modal.Title`, `Modal.Subhead`, `Modal.Body` and/or `Modal.Footer`. */
  children: _propTypes.default.node,
  /** Custom classes to add to the **Modal** component's outermost `<div>` tag. */
  className: _propTypes.default.string,
  /** Custom classes applied to the modal container (`<body>` by default)
   * when the modal is open, and removed when it is closed. */
  containerClassName: _propTypes.default.string,
  /** Properties to enable ability to drag the **Modal** to another position by
   * clicking and holding (or focusing and using arrow keys) on the **Modal.Header**.
   *
   * `screenReaderInstruction` (string): Assistive text communicated to screen
   * reader users when **Modal.Header** is focused and draggable is enabled.
   * Use `CoreUIComponents.draggableModal`.
   *
   * `onDragStart` (func): Callback for start of drag event (mouse only).
   *
   * `onDragEnd` (func): Callback for end of drag event (mouse only).
   *
   * `onKeyDown` (func): Callback for keydown event on **Modal.Header**.
   * */
  draggable: _propTypes.default.shape({
    screenReaderInstructions: _CustomPropTypes.default.localizedString('CoreUIComponents.draggableModal').isRequired,
    onDragStart: _propTypes.default.func,
    onDragEnd: _propTypes.default.func,
    onKeyDown: _propTypes.default.func
  }),
  /** When true, the **Modal** will take up the majority of the browser window,
   * obscuring underlying content. */
  fullscreen: _propTypes.default.bool,
  /** Determines whether the dialog is a modal. Renders a backdrop and traps focus. */
  isModal: _propTypes.default.bool,
  /** Custom classes to add to the **Modal** content’s outermost `<div>` tag. */
  modalContainerClassName: _propTypes.default.string,
  /** Props to spread to the **Modal** content’s outermost `<div>` tag. */
  modalContainerProps: _propTypes.default.object,
  /** Props to spread to the **Modal** content’s inner `<div>` tag. */
  modalContentProps: _propTypes.default.object,
  /** Properties to enable ability to resize the **Modal** by clicking
   * and holding (or focusing and using arrow keys) on the resizing handle
   * in **Modal.Footer**.
   *
   * `handleLabel` (string): Provides an accessible label for the resizing handle.
   * Use `CoreUIComponents.resizableModal`.
   *
   * `height` (number): initial height for the modal in pixels.
   *
   * `width` (number): initial width for the modal in pixels.
   *
   * `maxHeight` (number): Maximum height for the modal in pixels.
   *
   * `maxWidth` (number): Maximum width for the modal in pixels.
   *
   * `minHeight` (number): Minimum height for the modal in pixels.
   *
   * `minWidth` (number): Minimum width for the modal in pixels.
   *
   * `onDragStart` (func): Callback for start of drag event (mouse only).
   *
   * `onDragEnd` (func): Callback for end of drag event (mouse only).
   *
   * `onKeyDown` (func): Callback for keydown event on resizing handle in **Modal.Footer**.
   * */
  resizable: _propTypes.default.shape({
    handleLabel: _CustomPropTypes.default.localizedString('CoreUIComponents.resizableModal').isRequired,
    height: _propTypes.default.number,
    width: _propTypes.default.number,
    maxHeight: _propTypes.default.number,
    maxWidth: _propTypes.default.number,
    minHeight: _propTypes.default.number,
    minWidth: _propTypes.default.number,
    onDragStart: _propTypes.default.func,
    onDragEnd: _propTypes.default.func,
    onKeyDown: _propTypes.default.func
  }),
  /** Size of the **Modal**. Options are 'xl', 'lg', 'md', 'sm'. */
  size: _propTypes.default.oneOf(MODAL_SIZES),
  /** Internal use only */
  customFocusManager: _propTypes.default.func
});
Modal.Body = _ModalBody.ModalBody;
Modal.Header = _ModalHeader.ModalHeader;
Modal.Title = _ModalTitle.ModalTitle;
Modal.Footer = _ModalFooter.ModalFooter;
Modal.Subhead = _ModalSubhead.ModalSubhead;
var _default = exports.default = Modal;